import { BgRetina } from 'app/components/ui/BgRetina'
import { Container } from 'app/components/ui/Container'
import { Text } from 'app/components/ui/Text'
import { useLayout } from 'app/contexts/LayoutProvider'
import React, { useLayoutEffect } from 'react'
import styled from 'styled-components'

import { LoginForm } from './LoginForm'

export const Login = (): JSX.Element => {
  const { updateLayoutData } = useLayout()

  useLayoutEffect(() => {
    updateLayoutData({
      title: 'Area sponsor Marketing',
      subTitle: 'Accedi al servizio',
      headerVariant: 'authentication',
    })
  }, [updateLayoutData])

  return (
    <BgRetina bgImage='https://res.cloudinary.com/estra/image/upload/v1628251971/estra20dev/sponsor/login/login_bg.svg'>
      <Container>
        <PageGrid>
          <TextColumn>
            <Text variant='s20'>
              Questa piattaforma gestisce le procedure di gestione delle
              richieste di sponsorizzazione.
            </Text>
          </TextColumn>
          <FormColumn>
            <LoginForm />
          </FormColumn>
        </PageGrid>
      </Container>
    </BgRetina>
  )
}

const PageGrid = styled.div`
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;

  display: grid;
  grid-gap: 4rem;
  justify-items: center;

  grid-template-columns: 1fr;

  @media (min-width: ${({ theme }) => theme.bp.desktop}) {
    grid-template-columns: 3fr 2fr;
  }
`
const TextColumn = styled.div`
  max-width: 700px;
  color: ${({ theme }) => theme.color.primari.grigioEstra};

  @media (min-width: ${({ theme }) => theme.bp.desktop}) {
    margin-top: 5rem;
  }
`

const FormColumn = styled.div``
